// extracted by mini-css-extract-plugin
export default {"release_title":"ReleasesPageTitle_release_title__zdF6S"};